import { Bucket } from './bucket';
import { sumBy } from 'lodash';
import z from 'zod';

export type ExpensesSummary = z.infer<typeof ExpensesSummary>;
export type AggregatedBucket = z.infer<typeof AggregatedBucket>;

export const ExpensesSummary = z.object({
    count: z.number(),
    sum: z.number(),
    breakfastCount: z.number(),
    lunchCount: z.number(),
    dinnerCount: z.number(),
    overnightCount: z.number(),
});

export const AggregatedBucket = Bucket.and(
    z.object({
        expensesSummary: ExpensesSummary.optional(),
    }),
);

export function getAggregatedBucket(bucket: Bucket): AggregatedBucket {
    if (bucket.type !== 'trip') {
        return bucket;
    }

    return {
        ...bucket,
        expenses: [],
        expensesSummary: {
            count: bucket.expenses.length,
            sum: sumBy(bucket.expenses, (e) => e.sum),
            breakfastCount: sumBy(bucket.expenses, (e) => (e.breakfast ? 1 : 0)),
            lunchCount: sumBy(bucket.expenses, (e) => (e.lunch ? 1 : 0)),
            dinnerCount: sumBy(bucket.expenses, (e) => (e.dinner ? 1 : 0)),
            overnightCount: sumBy(bucket.expenses, (e) => (e.overnight ? 1 : 0)),
        },
    };
}
